module.exports = {
  PAYMENT_TYPE: {
    REGULAR: 'REGULAR',
    PRIORITY: 'PRIORITY'
  },
  CHARGE_TYPE: {
    OURS: 'OURS',
    SHARED: 'SHARED'
  }
};
